import FeatureGates from '@atlaskit/feature-gate-js-client';

import { DEFAULT_STATSIG_EXPERIMENT_CONFIG, STATSIG_SEARCH_BACKEND_LAYER } from '../../constants';

type ExperimentKeys = keyof typeof DEFAULT_STATSIG_EXPERIMENT_CONFIG;

export const getBackendExperimentConfig = (onErrorFn?: (error: any) => any) => {
	const isRequestDrivenExperimentationEnabled = FeatureGates.checkGate(
		'request_driven_experimentation_enabled',
	);

	if (!isRequestDrivenExperimentationEnabled) {
		return;
	}

	let response = { ...DEFAULT_STATSIG_EXPERIMENT_CONFIG };

	try {
		const layer = FeatureGates.getLayer(STATSIG_SEARCH_BACKEND_LAYER);

		for (const [key, value] of Object.entries(response)) {
			response[key as ExperimentKeys] = layer.get(key, value);
		}
	} catch (error) {
		onErrorFn?.(error);
	}

	return response;
};
